import React from 'react'
import { css } from '@emotion/css'
import styles from './styles'

const Switch = () => (
  <div className={styles.container}>
    <a href="/candidate/signup" className={css(styles.button, styles.active)}>
      Find a dev job
    </a>
    <a href="/employers/signup" className={styles.button}>
      Hire developers
    </a>
  </div>
)

export default Switch
